import React, { useState, useEffect } from "react";
import CaseAppointmentSummary from "../CommonDashboard/CaseManagement/CaseAppointmentSummary";
import CaseActionSummary from "../CommonDashboard/CaseManagement/CaseActionSummary";
import CaseSummary from "../CommonDashboard/CaseManagement/CaseSummaryDetails";
import CaseVolumeSummary from "../CommonDashboard/CaseManagement/CaseVolumeSummary";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import LatestCaseSummary from "../CommonDashboard/CaseManagement/LatestCaseSummary";
import CaseRushNotesSummary from "../CommonDashboard/CaseManagement/CaseRushNotesSummary";
import DoctorWiseSummary from "../CommonDashboard/CaseManagement/DoctorWiseSummary";
import HREStackBarSummary from "../CommonDashboard/CaseManagement/HREStackBarSummary";

interface SpApCmSdSummaryTypeProps {
  onTabChange: () => void;
  userRole: string;
}

const SpApCmSdSummaryType: React.FC<SpApCmSdSummaryTypeProps> = ({
  onTabChange,
  userRole,
}) => {
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const [showRushNotesSummary, setShowRushNotesSummary] = useState(false);

  return (
    <Container fluid className="px-4 dashboard">
      <Row>
        {!showRushNotesSummary ? (
          <Col md={3} className="latestcase d-flex align-items-stretch">
            <LatestCaseSummary
              openDropdown={openDropdown}
              setOpenDropdown={setOpenDropdown}
              setShowRushNotesSummary={setShowRushNotesSummary}
            />
          </Col>
        ) : (
          <Col md={3} className="latestcase d-flex align-items-stretch RushCase">
            <CaseRushNotesSummary
              openDropdown={openDropdown}
              setOpenDropdown={setOpenDropdown}
              setShowRushNotesSummary={setShowRushNotesSummary}
            />
          </Col>
        )}
        <Col md={6} className=" caseactions d-flex align-items-stretch ">
          <CaseActionSummary
            onTabChange={onTabChange}
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
          />
        </Col>
        <Col md={3} className="appointments d-flex align-items-stretch">
          <CaseAppointmentSummary />
        </Col>
      </Row>

      <Row className="mt-4 mb-4 case-summary">
        <Col md={6}>
          <CaseSummary
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
          />
        </Col>
        <Col md={6}>
          <DoctorWiseSummary
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
          />
        </Col>
      </Row>
      <Row className="mt-4 mb-4 case-summary">
        <Col md={12}>
          <HREStackBarSummary
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
          />
        </Col>
      </Row>
      <Row className="mt-4 mb-4 case-summary">
        <Col md={12}>
          <CaseVolumeSummary
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default SpApCmSdSummaryType;
